import script from "./headerComponentAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./headerComponentAdmin.vue?vue&type=script&setup=true&lang=ts"

import "./headerComponentAdmin.vue?vue&type=style&index=0&id=11e7604c&lang=css"

const __exports__ = script;

export default __exports__